import { memo } from "react";
import { Box, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import { useFormContext } from "@4uhub/lib4uhub";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TIntegrationRuleMovForm } from "./integrationRuleMovSchema";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

type TDoctorObtainMode = "SCHEDULE" | "LAST_ENCOUNTER_OF_DAY";

export const DoctorObtainMode = memo(() => {
  const { t } = useTranslation();

  const { setValue, control } = useFormContext<TIntegrationRuleMovForm>();

  const doctorObtainMode = useWatch({
    control,
    name: "doctorObtainMode",
  });

  const selected: TDoctorObtainMode = doctorObtainMode ?? "SCHEDULE";

  const radioOptions: { id: TDoctorObtainMode; label: string }[] = [
    {
      id: "SCHEDULE",
      label: t(translationPath + "doctor_obtain_mode_schedule"),
    },
    {
      id: "LAST_ENCOUNTER_OF_DAY",
      label: t(translationPath + "doctor_obtain_mode_last_encounter_of_day"),
    },
  ];

  const handleChange = (id: TDoctorObtainMode) => {
    setValue("doctorObtainMode", id, { shouldValidate: true });
  };

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle2" fontWeight="bold">
        {t(translationPath + "doctor_obtain_mode")}
      </Typography>

      <RadioGroup>
        {radioOptions.map((opt) => (
          <Box key={opt.id} sx={{ display: "flex" }}>
            <FormControlLabel
              label={opt.label}
              sx={{ width: "fit-content", mr: 1 }}
              control={
                <Radio
                  checked={selected === opt.id}
                  onChange={() => handleChange(opt.id)}
                />
              }
            />
          </Box>
        ))}
      </RadioGroup>
    </Grid>
  );
});
